import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, byteSize, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './housing.reducer';

export const HousingDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const housingEntity = useAppSelector(state => state.housing.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="housingDetailsHeading">
          <Translate contentKey="fivePlusApp.housing.detail.title">Housing</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{housingEntity.id}</dd>
          <dt>
            <span id="imageName">
              <Translate contentKey="fivePlusApp.housing.imageName">Image Name</Translate>
            </span>
          </dt>
          <dd>{housingEntity.imageName}</dd>
          <dt>
            <span id="topics">
              <Translate contentKey="fivePlusApp.housing.topics">Topics</Translate>
            </span>
          </dt>
          <dd>{housingEntity.topics}</dd>
          <dt>
            <span id="approved">
              <Translate contentKey="fivePlusApp.housing.approved">Approved</Translate>
            </span>
          </dt>
          <dd>{housingEntity.approved ? 'true' : 'false'}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="fivePlusApp.housing.description">Description</Translate>
            </span>
          </dt>
          <dd>{housingEntity.description}</dd>
          <dt>
            <span id="link">
              <Translate contentKey="fivePlusApp.housing.link">Link</Translate>
            </span>
          </dt>
          <dd>{housingEntity.link}</dd>
          <dt>
            <span id="createdDate">
              <Translate contentKey="fivePlusApp.housing.createdDate">Created Date</Translate>
            </span>
          </dt>
          <dd>
            {housingEntity.createdDate ? <TextFormat value={housingEntity.createdDate} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="modifiedDate">
              <Translate contentKey="fivePlusApp.housing.modifiedDate">Modified Date</Translate>
            </span>
          </dt>
          <dd>
            {housingEntity.modifiedDate ? <TextFormat value={housingEntity.modifiedDate} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <Translate contentKey="fivePlusApp.housing.user">User</Translate>
          </dt>
          <dd>{housingEntity.user ? housingEntity.user.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/housing" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/housing/${housingEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default HousingDetail;
